import type { Meta, StoryObj } from "@storybook/react";

import { ProgressBar } from "@/ui/core";
import type { ProgressBarProps } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<ProgressBarProps> = {
  title: "Core/Progress Bar",
  component: ProgressBar,
  argTypes: {
    currentStep: {
      control: { max: 6, min: 0, step: 1, type: "range" },
    },
    totalSteps: {
      control: "number",
    },
  },
  args: {
    currentStep: 2,
    totalSteps: 6,
  },
  render: (args) => (
    <Box paddingHorizontal={24} paddingTop={40} width="100%">
      <ProgressBar {...args} />
    </Box>
  ),
};

type Story = StoryObj<ProgressBarProps>;

const Default: Story = {};

const HalfComplete: Story = {
  args: {
    currentStep: 3,
    totalSteps: 6,
  },
};

const Complete: Story = {
  args: {
    currentStep: 6,
    totalSteps: 6,
  },
};

export { Complete, Default, HalfComplete };
export default StoryMeta;
